import { __ } from '@wordpress/i18n';
import { InspectorControls } from '@wordpress/block-editor';
import {
  BaseControl,
  SelectControl,
  TextControl,
  ToggleControl,
} from '@wordpress/components';

import ColorPicker from '../../components/ColorPicker';
import PanelBody from '../../components/PanelBody';
import Slider from '../../components/Slider';

export default function Inspector({ attributes, setAttributes }) {
  const {
    text,
    separator,
    repeat,
    size,
    textInset,
    centreBackground,
    spin,
    spinDuration,
    spinDirection,
  } = attributes;

  return (
    <InspectorControls>
      <PanelBody title={__('Badge', 'brandy-blocks')} initialOpen>
        {/*
          The phrase lives here rather than on the canvas: text bent around a
          circle cannot host a caret, so there is nowhere on the badge itself to
          type it.
        */}
        <TextControl
          label={__('Phrase', 'brandy-blocks')}
          value={text}
          onChange={(value) => setAttributes({ text: value })}
          __nextHasNoMarginBottom
          __next40pxDefaultSize
        />

        <TextControl
          label={__('Separator', 'brandy-blocks')}
          value={separator}
          onChange={(value) => setAttributes({ separator: value })}
          help={__('Sits between each repeat.', 'brandy-blocks')}
          __nextHasNoMarginBottom
          __next40pxDefaultSize
        />

        <Slider
          label={__('Times around', 'brandy-blocks')}
          value={repeat}
          onChange={(value) => setAttributes({ repeat: value })}
          min={1}
          max={8}
        />

        <Slider
          label={__('Diameter', 'brandy-blocks')}
          value={size}
          onChange={(value) => setAttributes({ size: value })}
          min={80}
          max={520}
        />

        {/*
          Measured to the text's baseline, and letters on a circle grow outward
          from it — so below roughly one cap height the glyphs start to overhang
          the badge's edge. The floor keeps the obvious wrong end of the slider
          out of reach.
        */}
        <Slider
          label={__('Text inset from edge', 'brandy-blocks')}
          value={textInset}
          onChange={(value) => setAttributes({ textInset: value })}
          min={4}
          max={Math.round(size / 2)}
        />

        {/*
          A colour of its own rather than the block's background support, which
          paints the whole medallion: the two-tone look in the reference is a
          ring band in one colour and the disc it encloses in another.
        */}
        <BaseControl.VisualLabel>
          {__('Centre background', 'brandy-blocks')}
        </BaseControl.VisualLabel>
        <ColorPicker
          color={centreBackground}
          onChange={(value) => setAttributes({ centreBackground: value })}
        />
      </PanelBody>

      <PanelBody title={__('Motion', 'brandy-blocks')} initialOpen={false}>
        <ToggleControl
          label={__('Rotate', 'brandy-blocks')}
          help={__('Held still while editing; it turns on the front end.', 'brandy-blocks')}
          checked={spin}
          onChange={(value) => setAttributes({ spin: value })}
          __nextHasNoMarginBottom
        />

        {/* Nothing below this acts on anything once rotation is off. */}
        {spin && (
          <>
            <Slider
              label={__('Seconds per turn', 'brandy-blocks')}
              value={spinDuration}
              onChange={(value) => setAttributes({ spinDuration: value })}
              min={2}
              max={60}
            />

            <SelectControl
              label={__('Direction', 'brandy-blocks')}
              value={spinDirection}
              onChange={(value) => setAttributes({ spinDirection: value })}
              options={[
                { value: 'clockwise', label: __('Clockwise', 'brandy-blocks') },
                {
                  value: 'counter-clockwise',
                  label: __('Counter-clockwise', 'brandy-blocks'),
                },
              ]}
              __nextHasNoMarginBottom
              __next40pxDefaultSize
            />
          </>
        )}
      </PanelBody>
    </InspectorControls>
  );
}
